import React from 'react'

import IconStar from 'components/UI/Icons/IconStar'
import Typography from 'components/UI/Typography/Typography'

import { RatingsProps } from './types'

import styles from './RatingLabel.module.css'

type RatingLabelProps = {
  stars: RatingsProps
}

const RatingLabel: React.FC<RatingLabelProps> = ({ stars }) => (
  <div className={styles.ratingLabel}>
    <div className={styles.number}>
      <Typography.BodySmallBold>{stars}</Typography.BodySmallBold>
    </div>
    <IconStar className={styles.icon} />
  </div>
)

export default RatingLabel
